import React from 'react';
import Typography from "@mui/material/Typography";
import {PROJECT} from '../../utils/constant';

const Footer = () => {
    return <div className='footer'>
        <Typography variant="h3" sx={{color: '#37391F', fontSize: '15px', fontWeight: 'bold', marginTop: '20px', textTransform: 'uppercase', fontFamily: 'Roboto flex'}}>© 2025 {PROJECT.NAME}</Typography>
    </div>}

export default Footer;
